import React, { FC } from 'react';
import { InfoButtonProps } from '.';
const InfoButtonTemplate: FC<InfoButtonProps> = (props) => {
    const { className } = props;

    return (
        <div className={className}>
            <button {...{ ...props, className: 'InfoButton' }} />
        </div>
    );
};
export default InfoButtonTemplate;
